import { SmartComponent } from "smart-component-js";

class RecipeCarouselLandingComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      console.error("Swiper non è definito.");
      return;
    }

    console.log("Initializing thumbs Swiper");
    this.thumbsSwiper = new Swiper(this.element.querySelector(".mySwiper"), {
      spaceBetween: 10,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true,
    });

    console.log("Initializing main Swiper");
    this.mainSwiper = new Swiper(this.element.querySelector(".mySwiper2"), {
      spaceBetween: 10,
      navigation: {
        nextEl: this.element.querySelector(".recipe-carousel__button--right"),
        prevEl: this.element.querySelector(".recipe-carousel__button--left"),
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
    });

    console.log("Swiper initialization complete");
  }

  initThumbNavigation() {}
}

export default RecipeCarouselLandingComponent;
